module.exports = __webpack_public_path__ + "static/media/BJ Miller.a7457a58.png";